import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

function OrderDateField({ value, onChange, className = "" }) {
  return (
    <div className="mt-4">
      <label htmlFor="order-date" className="block text-left text-sm font-medium text-gray-700 mb-1">
        Date de commande
      </label>
      <Flatpickr
        value={value}
        onChange={(dates) => {
          if (dates.length > 0) onChange(dates[0]);
        }}
        options={{
          dateFormat: "d/m/Y",
          allowInput: false,
          disableMobile: true,
        }}
        className={`input-style w-full ${className}`}
        placeholder="Date de commande"
      />
    </div>
  );
}

export default OrderDateField;
